export const MESSAGE_ROLES = {
  USER: "user",
  ASSISTANT: "assistant",
}

export const ERROR_CODES = {
  CHAT_CONTINUE_THREAD_WITH_MESSAGE_CONFLICT: "CHAT_CONTINUE_THREAD_WITH_MESSAGE_CONFLICT",
}

export const MAX_TABLE_PREVIEW_ROWS = 3

// agentType tags a thread to its originating surface. The standalone agent-chat page uses MANAGED;
// the legacy AI Teammate drawer uses AICHAT. Mirrors pi-server's AGENT_TYPES.
export const MANAGED_AGENT_TYPE = "managed"
export const AICHAT_AGENT_TYPE = "aichat"

export const STARTER_PROMPTS = [
  {
    id: "ytd-perf-decomposed",
    theme: "performance",
    text: "What's my YTD performance, broken into total, factor, and idiosyncratic return?",
  },
  {
    id: "style-exposures-today",
    theme: "factor-exposures",
    text: "What are my largest style factor exposures today?",
  },
  {
    id: "risk-contributors-top-bottom",
    theme: "risk",
    text: "What are my top and bottom 5 security contributors to factor risk today?",
  },
  {
    id: "exposure-change-week",
    theme: "factor-exposures",
    text: "What style factor exposures changed the most over the past week?",
  },
  {
    id: "drawdown-year",
    theme: "performance",
    text: "What was my largest drawdown in the last year, and what drove it?",
  },
]

export const PROMPT_CATEGORIES = [
  {
    theme: "performance",
    label: "Performance & Returns",
    prompts: [
      {
        id: "perf-ytd-active",
        theme: "performance",
        text: "What's my YTD return — active, portfolio-only, and benchmark-only?",
      },
      {
        id: "perf-mtd-qtd",
        theme: "performance",
        text: "What's my MTD and QTD return?",
      },
      {
        id: "perf-monthly-decomposed",
        theme: "performance",
        text: "What's my monthly total, factor, and idio $ return since 2024?",
      },
      {
        id: "perf-drawdown-year",
        theme: "performance",
        text: "What was my largest performance drawdown in the last year — when, how long, and what drove it?",
      },
      {
        id: "perf-by-industry",
        theme: "performance",
        text: "What's my total return by industry?",
      },
    ],
  },
  {
    theme: "risk",
    label: "Risk & Volatility",
    prompts: [
      {
        id: "risk-all-metrics",
        theme: "risk",
        text: "Show all current risk metrics for my portfolio.",
      },
      {
        id: "risk-weekly-2025",
        theme: "risk",
        text: "What's my total risk each week in 2025, and how does it change week over week?",
      },
      {
        id: "risk-volatility-last-month",
        theme: "risk",
        text: "What was my volatility last month?",
      },
      {
        id: "risk-specific-contributors",
        theme: "risk",
        text: "Which securities are contributing most to my specific risk today?",
      },
    ],
  },
  {
    theme: "factor-exposures",
    label: "Factor Exposures",
    prompts: [
      {
        id: "exp-largest-style-today",
        theme: "factor-exposures",
        text: "What are my largest style exposures today?",
      },
      {
        id: "exp-changed-last-week",
        theme: "factor-exposures",
        text: "Which style factor exposures changed the most since last week?",
      },
      {
        id: "exp-biggest-changes-week",
        theme: "factor-exposures",
        text: "How have my biggest exposures changed over the past week?",
      },
      {
        id: "exp-momentum-drivers",
        theme: "factor-exposures",
        text: "Which stocks drove the large change in my momentum exposure over the last month?",
      },
    ],
  },
  {
    theme: "thematic",
    label: "Thematic Insights",
    prompts: [
      {
        id: "theme-largest-ai",
        theme: "thematic",
        text: "What are the largest AI-related themes in my portfolio?",
      },
      {
        id: "theme-tariffs",
        theme: "thematic",
        text: "Which available themes are associated with tariffs?",
      },
    ],
  },
  {
    theme: "screening",
    label: "Market Screening",
    prompts: [
      {
        id: "screen-us-tech",
        theme: "screening",
        text: "Find US tech stocks with market cap > $500M and idiosyncratic risk below 50%.",
      },
      {
        id: "screen-mid-energy",
        theme: "screening",
        text: "Find mid-cap energy stocks, excluding any from Venezuela.",
      },
    ],
  },
  {
    theme: "security",
    label: "Security Deep-Dive",
    prompts: [
      {
        id: "sec-tsla-returns",
        theme: "security",
        text: "What were the total, factor, and idiosyncratic returns for TSLA this year?",
      },
      {
        id: "sec-nvda-risk",
        theme: "security",
        text: "Show all risk metrics for NVDA as of today.",
      },
    ],
  },
  {
    theme: "using-op",
    label: "Using OP",
    prompts: [
      {
        id: "using-op-thematic-beta",
        theme: "using-op",
        text: "How is the thematic beta calculated?",
      },
      {
        id: "using-op-compare-portfolios",
        theme: "using-op",
        text: "How can I compare my portfolio to another portfolio in the dashboard?",
      },
    ],
  },
]

export const NUDGE_PROMPTS = [
  {
    id: "nudge-style-factor-exposures",
    text: "What are my largest style factor exposures today?",
  },
  {
    id: "nudge-largest-drawdown",
    text: "What was my largest drawdown in the last year, and what drove it?",
  },
]
